import React from 'react';
import PropTypes from 'prop-types';
import TagTreeSelector from 'legacy-src/components/assessment/TagTreeSelector';

import './TagSelectors.scss';

class TagSelectors extends React.Component {
  constructor(props) {
    super(props);

    this.eliminateTags = this.eliminateTags.bind(this);
  }
  render() {
    const {
      cursor,
      tagCategories,
      showAllTags = false,
      flattenHierarchy,
      isCollapsible,
      enableHierarchicalSelection,
    } = this.props;

    const { updateAllCategories, eliminateTags } = this;

    function renderFilter(tag) {
      const tagCategoryId = tag.id;
      const props = {
        filterCursor: cursor,
        //cursor: cursor.sub(tag.id, []),
        key: tagCategoryId,
        tagCategory: tag,
        showAllTags,
        updateTags: updateAllCategories,
        eliminateTags,
        tagCategories,
        selectType: tag.single_select ? 'single' : 'multiple',
        flattenHierarchy,
        tagCategoryId,
        isCollapsible,
        enableHierarchicalSelection,
      };
      return <TagTreeSelector {...props} />;
    }

    return (
      <div className="TagSelectors">
        <div className="TagSelectors--full">
          <h3 className="text-18 font-medium mb-10">Required Keywords Tags</h3>
          <div className="TagSelectors__container gap-x-3.5">
            {tagCategories && tagCategories.required_editable.map(renderFilter)}
          </div>
        </div>
        {tagCategories && tagCategories.additional_editable.length > 0 && (
          <div className="TagSelectors--full">
            <h4 className="text-18 font-medium mb-10">
              Optional Keywords Tags
            </h4>
            <div className="TagSelectors__container gap-x-3.5">
              {tagCategories &&
                tagCategories.additional_editable.map(renderFilter)}
            </div>
          </div>
        )}
      </div>
    );
  }

  // An exercise in managing grossness
  // Tags can be associated with more than one tag category, e.g.:
  // {
  //     "42": [1172, 1177, 1148],
  //     "43": [1172],
  //     "44": [1177],
  // }
  // Note that usually (always?) one category is a "child" of the other in the hierarchy.
  // Because each TagTreeSelector only works on one category,
  // removing a tag in multiple categories is a problem.
  // It would be nice to make the API do this before returning the data (AFAICT there's no point)
  // rather than having to do extra work here.
  eliminateTags(tagIds) {
    // This function goes through all categories and removes the given tag ID.
    const { value } = this.props.cursor;
    const tags = {};
    _.keys(value).map((categoryId) => {
      const updated = _.difference(value[categoryId], tagIds);
      if (updated.length) {
        tags[categoryId] = updated;
      }
    });
    this.props.cursor.requestChange(tags, this.props.tagCategories);
  }
}

TagSelectors.propTypes = {
  cursor: PropTypes.shape({
    requestChange: PropTypes.func,
    sub: PropTypes.func,
    value: PropTypes.object,
  }),
  tagCategories: PropTypes.object,
  existingTags: PropTypes.object,
  editorView: PropTypes.bool,
  showAllTags: PropTypes.bool,
  flattenHierarchy: PropTypes.object.isRequired,
};

export default TagSelectors;
